<template>
  <div>
    <form>
      <div class="row">
        <div class="alert alert-warning" role="alert" style="color: black">
          <b>Notice:</b> If a device is in multiple zones, you may experience strange behavior. For example, two "Play Sound File" steps where a device is in both zones.
        </div>
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="ddlOrderType">Order Type</label>
            <select
              class="form-control"
              id="ddlOrderType"
              v-model="event_step.event_step_order_type_id"
              disabled
            >
              <option
                v-for="event_step_order_type in event_step_order_types"
                :key="event_step_order_type.event_step_order_type_id"
                v-bind:value="event_step_order_type.event_step_order_type_id"
              >{{ event_step_order_type.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="ddlCommandType">Command Type</label>
            <select
              class="form-control"
              id="ddlCommandType"
              v-model="event_step.event_step_command_type_id"
              disabled
            >
              <option value="0">Select..</option>
              <option
                v-for="event_step_command_type in filtered_event_step_command_types"
                :key="event_step_command_type.event_step_command_type_id"
                v-bind:value="event_step_command_type.event_step_command_type_id"
              >{{ event_step_command_type.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div v-if="[1,7,8,11,12].includes(event_step.event_step_command_type_id)">
            <div class="form-group">
              <label for="ddlZone">Zone</label>
              <select class="form-control" id="ddlZone" v-model="event_step.zone_id">
                <option value="0">Select..</option>
                <option
                  v-for="zone in filtered_zones"
                  :key="zone.zone_id"
                  v-bind:value="zone.zone_id"
                >[{{ zone.site.name }}] {{ zone.name }}</option>
              </select>
            </div>
          </div>
          <div v-if="event_step.event_step_command_type_id ===11">
            <div class="form-group">
              <label for="ddlFlasherType">Flasher Type</label>
              <select class="form-control" id="ddlFlasherType" v-model="event_step.flasher_type">
                <option
                  v-for="flasher_type in flasher_types"
                  :key="flasher_type.id"
                  v-bind:value="flasher_type.id"
                >{{ flasher_type.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="txtDisplayText">Display Text</label>
              <input
                type="text"
                class="form-control"
                id="txtDisplayText"
                v-model="event_step.display_text"
              />
            </div>
          </div>
          <div v-if="event_step.event_step_command_type_id === 1">
            <SoundDropDownAndPreview :tag="event.event_type_id === 3 ? 'alert' : 'announcement'" v-model="event_step.sound"></SoundDropDownAndPreview>
          </div>
          <div v-if="event_step.event_step_command_type_id === 2">
            <div class="form-group">
              <label for="txtBarixCommand">Barix Command</label>
              <input
                type="text"
                class="form-control"
                id="txtBarixCommand"
                v-model="event_step.barix_command"
              />
            </div>
          </div>
          <div v-if="event_step.event_step_command_type_id === 3">
            <div class="form-group">
              <label for="numSleepDuration">Sleep Duration</label>
              <input
                type="number"
                class="form-control"
                id="numSleepDuration"
                v-model="event_step.sleep_duration"
              />
            </div>
          </div>
          <div v-if="event_step.event_step_command_type_id === 4">
            <div class="form-group">
              <label for="ddlAlertSteps">Go to Step</label>
              <select class="form-control" id="ddlAlertSteps" v-model="event_step.to_event_step_id">
                <option value="0">Select..</option>
                <option
                  v-for="_event_step in filtered_event_steps"
                  :key="_event_step.event_step_id"
                  v-bind:value="_event_step.event_step_id"
                >{{ _event_step.order }} - {{ _event_step.event_step_command_type.name }}</option>
              </select>
            </div>
          </div>
          <div v-if="event_step.event_step_command_type_id === 5">
            <div class="form-group">
              <label for="txtMessage">Message</label>
              <input class="form-control" type="text" id="txtMessage" v-model="event_step.message" />
              <small
                class="form-text text-muted"
              >Contacts set to receive 'all alerts sms' will not show up in the below list but will automatically be sent the sms message.</small>
            </div>
          </div>
          <div v-if="[7,8].includes(event_step.event_step_command_type_id)">
            <div class="form-group">
              <label for="ddlVisuals">Visual</label>
              <select class="form-control" id="ddlVisuals" v-model="event_step.advanced_visual_id">
                <option value="0">Select..</option>
                <option
                  v-for="advanced_visual in filtered_advanced_visuals"
                  :key="advanced_visual.advanced_visual_id"
                  v-bind:value="advanced_visual.advanced_visual_id"
                >{{ advanced_visual.name }}</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <div class="col-6 mx-auto" v-if="event_step.event_step_id && event_step.advanced_visual_id !== 0">
          <AdvancedVisualPreview :advanced_visual="getVisual(event_step.advanced_visual_id)" />
        </div>
      </div>
    </form>
    <div class="row" v-if="event_step.event_step_command_type_id === 5">
      <div class="col-12">
        <div class="row">
          <div class="col-5">
            <div class="form-group">
              <label for="txtPhoneToAddName">Name</label>
              <input
                class="form-control"
                type="text"
                id="txtPhoneToAddName"
                v-model="phone_to_add.name"
              />
            </div>
            <div class="form-group">
              <label for="txtPhoneToAddPhoneNumber">Phone Number</label>
              <vue-tel-input
                :onlyCountries="['US']"
                :validCharactersOnly="true"
                @input="updatePhoneNumberProperties"
                v-model="phone_to_add.phone_number.display_text"
              ></vue-tel-input>
            </div>
          </div>
          <div class="col-2 middle-btn-col">
            <button type="button" class="btn btn-light" @click="addPhoneNumber()">
              <i class="fa fa-arrow-right fa-fw" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn btn-light" @click="removePhoneNumbers()">
              <i class="fa fa-trash fa-fw" aria-hidden="true"></i>
            </button>
          </div>
          <div class="col-5">
            <div class="card">
              <div class="card-header bg-hub-primary text-white">Phone Numbers</div>
              <div class="card-block">
                <select
                  multiple
                  class="form-control devices-select"
                  v-model="selected_phone_numbers"
                >
                  <option
                    v-for="event_step_phone_number in event_step.event_step_phone_numbers"
                    v-bind:value="event_step_phone_number.phone_number"
                    :key="event_step_phone_number.phone_number"
                  >{{ event_step_phone_number.name }} ({{ event_step_phone_number.phone_number }})</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import SoundDropDownAndPreview from '../../components/SoundDropDownAndPreview'
import AdvancedVisualPreview from '../Visual/AdvancedVisualPreview'
import { ZONE_TYPE, EVENT_TYPE } from '../../assets/js/resource-types'

export default {
  props: {
    event_id: {
      type: [Number, String],
      required: true
    },
    event_step_id: {
      type: [Number, String],
      required: true
    }
  },
  data: function () {
    return {
      phone_to_add: {
        name: '',
        phone_number: {
          display_text: '',
          properties: {
            isValid: false
          }
        }
      },
      selected_phone_numbers: [],
      flasher_types: [
        { id: 'simultaneously', name: 'Flash Simultaneously' },
        { id: 'alternately', name: 'Flash Alternately' },
      ],
    }
  },
  components: { SoundDropDownAndPreview, AdvancedVisualPreview },
  watch: {
    event_step_id: {
      handler(newEventStepId) {
        if(newEventStepId && newEventStepId !== 0)
          this.$store.dispatch('getEventStep', newEventStepId)
      },
      immediate: true
    } 
  },
  computed: {
    ...mapGetters({
      event: 'singleEvent',
      event_step: 'singleEventStep',
      event_steps: 'allEventSteps',
      event_step_order_types: 'allEventStepOrderTypes',
      event_step_command_types: 'allEventStepCommandTypes',
      feature_sms_enabled: 'featureSMSEnabled',
      feature_sms_max_phone_numbers: 'featureSMSMaxPhoneNumbers',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled',
      feature_g2_secure_enabled: 'featureG2SecureEnabled',
      advanced_visuals: 'allAdvancedVisuals',
      zones: 'allZones',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_zones() {
      // TODO Account for Zone Tags COMM-188
      return this.zones.filter(zone => {
        if ((zone.site_id === this.scoped_site_id || this.scoped_site_id === 1)
          && [7, 8].includes(this.event_step.event_step_command_type_id)
        ) {
          return zone.zone_type_id === ZONE_TYPE.Visual
        }
        return zone.zone_type_id !== ZONE_TYPE.Visual
      }
      )
    },
    filtered_event_step_command_types() {
      return this.event_step_command_types.filter(commandType => {
        switch (commandType.event_step_command_type_id) {
          case 1: // Play Sound File
          case 3: // Pause
            return true
          case 4: // Go To Step
            return this.event.event_type_id === EVENT_TYPE.Alert
          case 2: // Send Barix Command
            return this.event.device_id !== null && this.event.event_type_id === EVENT_TYPE.Alert
          case 5: // Send SMS
            return this.feature_sms_enabled && this.event.event_type_id === EVENT_TYPE.Alert
          case 6: // Send Email
            return false
          case 7: // Start Visual
          case 8: // Stop Visual
            return this.feature_visual_alert_enabled
          case 9: // Enable Phoenix
          case 10: // Disable Phoenix
            return this.event.event_type_id === EVENT_TYPE.Alert
          case 11: // Start Text
          case 12: // Stop Text
            return true
        }
      })
    },
    filtered_event_steps() {
      return this.event_steps.filter(
        eventStep =>
          eventStep.event_id === parseInt(this.event_id) &&
          eventStep.event_step_order_type_id ===
          parseInt(this.event_step.event_step_order_type_id)
      )
    },
    filtered_advanced_visuals() {
      return this.advanced_visuals.filter(v => v.event_id === parseInt(this.event_id))
    },
    filtered_sound_types() {
      return this.sound_types.filter(s => s.sound_type_id !== 1)
    },
    filtered_playlists() {
      return this.playlists.filter(playlist => playlist.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getEventStepOrderTypes')
    this.$store.dispatch('getEventStepCommandTypes')
    this.$store.dispatch('getZones')
  },
  methods: {
    getVisual(advancedVisualId) {
      return this.filtered_advanced_visuals.find(av => av.advanced_visual_id === advancedVisualId)
    },
    updatePhoneNumberProperties (num, data) {
      this.phone_to_add.phone_number.properties = data
    },
    addPhoneNumber () {
      if (
        this.event_step.event_step_phone_numbers.length <
        Number(this.feature_sms_max_phone_numbers)
      ) {
        if (!_.isEmpty(this.phone_to_add.name)) {
          if (this.phone_to_add.phone_number.properties.isValid) {
            this.event_step.event_step_phone_numbers.push({
              event_step_id: this.event_step_id,
              name: this.phone_to_add.name,
              phone_number: this.phone_to_add.phone_number.properties.number.replace(
                /\s/g,
                ''
              )
            })

            this.phone_to_add.name = ''
            this.phone_to_add.phone_number = {
              display_text: '',
              properties: { isValid: false }
            }
          } else {
            alert('Please enter a valid phone number.')
          }
        } else {
          alert('Please enter a name for the phone number.')
        }
      } else {
        alert(
          'The limit of ' +
            this.feature_sms_max_phone_numbers +
            ' phone numbers has been reached.'
        )
      }
    },
    removePhoneNumbers () {
      for (let i = 0; i < this.selected_phone_numbers.length; i++) {
        let selectedPhoneNumber = this.selected_phone_numbers[i]
        let phoneNumberToRemove = this.event_step.event_step_phone_numbers.find(
          function (ele) {
            if (ele.phone_number === selectedPhoneNumber) {
              return true
            }
          }
        )
        this.event_step.event_step_phone_numbers.splice(
          this.event_step.event_step_phone_numbers.indexOf(phoneNumberToRemove),
          1
        )
      }
    },
    submit () {
      this.$store.dispatch('addEditEventStep', { event_step: this.event_step })
        .then(() => {
          // eslist-disable-next-line
          $('#eventStepModal').modal('hide')
        })
    }
  }
}
</script>

<style scoped>
</style>
